export default __webpack_public_path__ + "static/media/en-flag.a4482e8d.svg";